const WIDTH = window.innerWidth;
const BREAKPOINT = 900;
const IS_MOBILE = window.innerWidth < 900;

export { WIDTH, BREAKPOINT, IS_MOBILE };
